

import * as React from "react";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import Autocomplete from "@mui/material/Autocomplete";
import Link from "@mui/material/Link";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import AppBar from "@mui/material/AppBar";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import SearchIcon from "@mui/icons-material/Search";
import { useState, useEffect } from "react";
import Navbar from "../../components/common/Navbar";
import { useStyles } from "../../assets/styles/Theme";
import { externalgetApi } from "../../services/external/externalApis";
import { RecipeItemdata } from "../../assets/Griddata"; // Import dataset
import VisibilityIcon from "@mui/icons-material/Visibility";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import ViewData from "../../components/grids/ViewDatagrid";
import { RECIPE_API_01, RECIPE_API_04, SETTINGS_API_07,SHOP_API_01 } from "../../api/ApiModel";
import {
  COMPCODE,
  LOCCODE,
  RESTCODE,
  STS,
  CHAINCODE,
  MENUTYPECODE,
} from "../../api/ApiModel";
import { currencyFormatLKR } from "../../utils/common/CurrencyFormat";
import AddToPhotosIcon from '@mui/icons-material/AddToPhotos';
import GradingIcon from '@mui/icons-material/Grading';
import {
  CON_STATUS_ACTIVE,
  CON_MENU_TYPE_CODE,
} from "../../utils/sys/Constants";
import { useSelector } from "react-redux";
import SearchAppBar from "../../components/common/search";
import ViewDataIcongrids from "../../components/grids/ViewDataIcongrids";
import ViewRecipe from "./ViewRecipe";
function RecipeItems() {
  const navigate = useNavigate();
  const theme = useTheme();
  const styles = useStyles(theme);

  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [selectedSHOP, setSelectedSHOP] = useState(null);
  const [datashop, setDatashop] = useState([]);
  const [selectedrestcode, setSelectedrestcode] = useState(null);
  const [filteredData, setFilteredData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE, LOCCODE, RESTCODE, USERNAME,GROUPCODE } = SYS_USER.USER_PARAM || {};
 



  useEffect(() => {
  const fetchData = async () => {
    try {
      const result = await externalgetApi(RECIPE_API_04, "get", {
        COMPCODE: COMPCODE,
        LOCCODE: LOCCODE,
        RESTCODE: RESTCODE,
        STS: CON_STATUS_ACTIVE,
      });

      // Assuming result has structure: { Table1: [...], Table2: [...] }
      if (result) {
        setDatashop(result);
        console.log("Table1 data:", result);
      } else {
        console.warn("Table1 not found in result", result);
        setDatashop([]); // Optional: reset to empty array
      }
    } catch (err) {
      console.error("Error fetching data:", err);
    }
  };
  
  fetchData();
}, []);



const mapResultToRows = (result) => {
  return result.map((item, index) => ({
    id: index + 1,
    MENUCODE: item.MENUCODE,
    MENUNAME: item.MENUNAME,
    MENUCATCODE: item.MENUCATCODE, // <-- Add this line
    // Add other fields if needed
  }));
};
  const handleSearchChange = (event) => {
    setSearchText(event.target.value);
  };

  useEffect(() => {
    if (datashop) {
      const filtered = datashop.filter((item) => {
  const menuname = item.MENUNAME || "";
  return menuname.toLowerCase().includes(searchText.toLowerCase());
});

      setFilteredData(filtered);
    }
  }, [searchText, datashop]);


const handleItemClick = (row, actionText) => {
  if (actionText === "Map Recipe") {
    if (row) {
      navigate(`/maprecipe`, {
        state: {
          MENUCODE: row.MENUCODE,
          MENUCATCODE: row.MENUCATCODE,
          MENUNAME: row.MENUNAME,
        
          actionText
        }
      });
    }
  }
};


const menuItems = [
  {
    icon: <GradingIcon />,
    text: "View Recipe",
    onClick: (row) => handleView(row),
  },
  {
    icon: <AddToPhotosIcon />,
    text: "Map Recipe",
    onClick: (row) => handleItemClick(row, "Map Recipe"),
  }
];

const [dialogOpen, setDialogOpen] = useState(false);
const [dialogData, setDialogData] = useState({ menucode: "", menucatcode: "", MENUNAME: "" });

const handleView = (row) => {
  setDialogData({
    menucode: row.MENUCODE,
    menucatcode: row.MENUCATCODE,
    MENUNAME: row.MENUNAME,
  });
  setDialogOpen(true);
};

const handleDialogClose = () => {
  setDialogOpen(false);
};



  const rows = filteredData ? mapResultToRows(filteredData) : [];

  return (
    <div>
      <Navbar />
      <AppBar sx={styles.AI_CustomAppBar1}>
        <Box sx={styles.AI_HeaderContainer1}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Breadcrumbs
                sx={styles.AI_breadcrumbs2}
                
                separator={<NavigateNextIcon fontSize="small" />}
              >
                <Link underline="none">Home</Link>
                <Link underline="none">Settings</Link>
                <Link underline="none">Recipe</Link>
              </Breadcrumbs>
            </Grid>
            <Grid item xs={12} md={6} >
              <Stack
                sx={styles.AI_fixedStack1}
                direction="row"
                justifyContent="flex-end"
                spacing={2}
                padding={1}
                ml={1}
              >
                <SearchAppBar
                  onChange={handleSearchChange}
                  value={searchText}
                />
             
                       <Button
                                    onClick={() => navigate("/maprecipe")}
                                  variant="contained"
                                  size="medium"
                                  startIcon={<AddCircleIcon />}
                                  sx={{
                                    background: theme.palette.primary.main,
                                    color: theme.palette.text.buttontxt,
                                    textTransform: "capitalize",
                                    letterSpacing: "2px",
                                    width: "80px",
                                  }}
                                >
                                  Add
                                </Button>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </AppBar>
      <ViewDataIcongrids
  columns={RecipeItemdata.columns}
  rows={rows.map((item) => ({ ...item, id: item.MENUCODE }))}
  menuItems={menuItems}
  tabletitle={RecipeItemdata.name}
  gridid="MENUCODE"
/>

<ViewRecipe
  open={dialogOpen}
  onClose={handleDialogClose}
  data={dialogData}
/>

    </div>
  );
}

export default RecipeItems;
